<template>
    <div>
        <div v-if="productAlerts.length==0 && !selectedAccount"></div>
        <div style="text-align: center; padding-top: 150px;" v-else-if="productAlerts.length==0 && selectedAccount"
        >
            No product alerts found for the selected vendor or seller.
        </div>
        <table v-else class="table" style="table-layout:fixed;">
            <thead style="position: sticky;">
                <tr>
                    <th style = "text-align: center;width:3%">
					    <input v-model="actionSelectionControl" type="checkbox" />
					</th>
					<th class="link" style="width: 10%; font-size: small;" v-on:click="sorting('created_on',$event)" >Event Time<i class="sort fa " :class="sort.field=='created_on'? sort.order =='asc' ? 'fa-arrow-up':'fa-arrow-down':''"></i></th>
                    <th style="width:7.5%; font-size: small;"><div>{{isSeller ? 'Seller' : 'Vendor'}}</div><div>(Brand)</div></th>
                    <th style="width:7.5%; font-size: small;">{{isSeller ? 'Seller ID' : 'Vendor Code'}}</th>
                    <th style="width:10%; font-size: small;">ASIN</th>
                    <th style="width:10%; font-size: small;">SKU</th>
                    <th style="width:10%; font-size: small;">{{isSeller ? 'Listing ID' : 'UPC'}}</th>
                    <th style="width:10%; font-size: small;">Created On</th>
                    <th style="width:15%; font-size: small;">Title</th>
                    <th style="width:15%; font-size: small;">Issue Category</th>
                    <th style="width:15%; font-size: small;">Work Status</th>
                    <th style="width:15%; font-size: small;">Last Updated</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in productAlerts" :key="item.asin + '_' + index" :class="index%2==0?'even':''">
                    <td style = "text-align: center;">
						<input v-model="item.isSelected" @change="addIssueToSelected(item)" type="checkbox"  />
					</td>
                    <td style="font-size: x-small;">
                        <div>{{getDate(item.event_timestamp)}}</div>
                        <div>{{getTime(item.event_timestamp)}}</div></td>
                    <td style="font-size: x-small;">{{item.brand_name || 'NOT FOUND'}} <span v-if="item.brand"> <br/> ({{item.brand}})</span></td>
                    <td style="font-size: x-small;">{{item.vendor_code || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">{{item.asin || item.asin1 || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">{{item.sku || item.seller_sku || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">{{item.upc || item.listing_id || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">{{ getDate(item.created_on) || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">{{item.producttitle || 'NOT FOUND'}}</td>
                    <td style="font-size: x-small;">
                        <div>{{item.issue_category}}</div>
                        <div>{{formatEnforcement(item.enforcement_action)}}</div></td>
                    <td style="font-size: x-small;">{{item.work_status}}</td>
                    <td style="font-size: x-small;">{{item.days_since_update}}</td>
                    <td style="vertical-align: middle !important;" class="row-add-edit">
                        <div class="row-add-edit">
                            <a href="javascript:void(0)" class="item-add-edit" data-toggle="dropdown"></a>
                            <div
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                                style="left:-58px"
                            >
                                <a class="grid-item ico-create-new remove-padding" @click="viewDetails(item)">Event History</a>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import moment from "moment";
import productAlertsStore from "../../store/product-alerts-store";

export default {
    name: 'IssuesGrid',
    data() {
        return {
            projectObj: {}
        }
    },
    components: {
    },
    mounted() {
    },
    computed: {
        isSeller:{
            set(val){
                this.$store.state.isSeller = val
            },
            get(){
                return this.$store.state.isSeller
            }
        },
        actionSelectionControl: {
            set(val) {
                this.$store.state.productAlerts.actionSelectionControl = val
                if (val) {
                    this.selectAllProduct()
                }
                else {
                    this.resetSelectAllProduct()
                }
            },
            get() {
                return this.$store.state.productAlerts.actionSelectionControl
            }
        },
        selectedIssues: {
            set(val) {
                this.$store.state.productAlerts.selectedIssues = val
            },
            get() {
                if(this.$store.state.productAlerts.selectedIssues.length == 0){
                    this.resetSelectAllProduct()
                }
                return this.$store.state.productAlerts.selectedIssues;
            }
        },
        sort: {
            set(val) {
                this.$store.commit("setSelectedSortOrder", val);
            },
            get() {
                return this.$store.state.selectedSortOrder;
            }
        },
        productAccendingOrder: {
            set(val) {
                this.$store.state.product.productAccendingOrder = val
                this.$store.commit('product/sortProductList')
            },
            get() {
                return this.$store.state.product.productAccendingOrder
            }
        },
		selectedAccount: {
			set(val) {
				 this.$store.state.productAlerts.selectedAccount = val
			},
			get() {
				 return this.$store.state.productAlerts.selectedAccount;
			}
		},
		grouping: {
			get() {
                return this.$store.state.product.grouping? this.$store.state.product.grouping:'Client'
			}
		},
        productAlerts: {
            get() {
                return this.$store.state.productAlerts.issuesList
            }
        }
    },
	watch:{
        selectedIssues(){},
        sort(){},
        isSeller: {
            async handler(){
                this.filterOptions = await this.$store.dispatch("productAlerts/getFilters")
            }
        }
	},
    methods: { 
        formatEnforcement(enforcement_action) {
            if (!enforcement_action) {
                return
            }
            
            if (enforcement_action.includes('CATALOG')){
                return '(Catalog Item Removed)'
            } else if (enforcement_action.includes('ATTRIBUTE')){
                return '(Attribute Suppressed)'
            } else if (enforcement_action.includes('LISTING')){
                return '(Listing Suppressed)'
            } else if (enforcement_action.includes('SEARCH')){
                return '(Search Suppressed)'
            }
        },
        selectAllProduct() {
            this.productAlerts.forEach(element => {
                element.isSelected = true
            });
            this.selectedIssues = JSON.parse(JSON.stringify(this.productAlerts))
        },
        resetSelectAllProduct() {
            this.productAlerts.forEach(element => {
                element.isSelected = false
            });
            this.selectedIssues = []
        },
        addIssueToSelected(item) {
            if (item.isSelected) {
                this.selectedIssues.push(JSON.parse(JSON.stringify(item)))
                console.log(this.selectedIssues)
            }
            else {
                this.removeProductFromSelected(item)
            }
        },
        removeProductFromSelected(item) {
            let index = this.selectedIssues.findIndex(element => {
                return element.id == item.id
            })
            this.selectedIssues.splice(index, 1)
            console.log(this.selectedIssues);
			this.$store.state.productAlerts.actionSelectionControl = false
        },
        viewDetails(item) {
            if (this.$route.path === '/productAlerts') {
                this.$store.state.productAlerts.selectedProduct = item
                this.$router.push({
                    path: `/productAlerts/${item.partneruuid}/${item.marketplace_id}/${item.asin}/${item.sku}`
                });
            }
        },
        getDate(data){
            return moment(data).local().format("YYYY-MM-DD")
        },
        getTime(data){
            return moment(data).local().format("hh:mm A")
        },
        sorting(field,event){
            if((event.currentTarget.children[0].classList[2]) == 'fa-arrow-up' || (event.currentTarget.children[0].classList[2]) == 'fa-arrow-down'){
                var pastEvent = true;
            }
            for(var i=0;i<document.getElementsByClassName('sort').length;i++){
                document.getElementsByClassName('sort')[i].classList.remove('fa-arrow-up');
                document.getElementsByClassName('sort')[i].classList.remove('fa-arrow-down');
            }
            if(pastEvent){
                this.sort.order ==  'desc' ? event.currentTarget.children[0].classList.add('fa-arrow-up') :event.currentTarget.children[0].classList.add('fa-arrow-down');
                pastEvent = false;
            }
            else{
                event.currentTarget.children[0].classList.add('fa-arrow-up')
            }
            this.sort = {
                field : field,
                order : (event.currentTarget.children[0].classList[2]) == 'fa-arrow-up' ? 'asc':'desc'
            }
        }
    }
}
</script>

<style lang="scss">
.hightlight {
    background-color: #3da3a7 !important;
    color: #fff;
}
.link { cursor: pointer; }

th {
    text-align: center;
    font-size: small;
}

td {
    text-align: center;
    font-size: x-small;
}

</style>
